import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PdfNotificationFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.61101 2.99929C5.62967 2.99964 5.64846 3 5.66717 3H5.5C5.53676 2.9979 5.57382 2.9986 5.61101 2.99929ZM12.4695 3C12.5544 3 12.6382 3.01116 12.7189 3.03267C12.6486 3.0112 12.5749 3 12.5 3H12.4695ZM20.25 10.805C20.2496 10.6615 20.2178 10.5187 20.1585 10.3911C20.218 10.5002 20.25 10.6235 20.25 10.75L20.25 10.805Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.1585 10.3911C20.2178 10.5187 20.2496 10.6615 20.25 10.805L20.25 10.75C20.25 10.6235 20.218 10.5002 20.1585 10.3911ZM12.4695 3C12.5544 3 12.6382 3.01116 12.7189 3.03267C12.6486 3.0112 12.5749 3 12.5 3H12.4695Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.75 5.93619C2.75236 4.3758 3.96784 3.08744 5.5 3C3.96635 3.08723 2.75 4.37373 2.75 5.93619Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.66717 3C5.61115 3 5.55523 2.99684 5.5 3C3.96784 3.08744 2.75236 4.3758 2.75 5.93619L2.77427 21.573C2.77678 23.1903 4.08211 24.5 5.69144 24.5H17.3328C18.5256 24.5 19.5512 23.7806 20.0033 22.75H9.5C8.39543 22.75 7.5 21.8546 7.5 20.75V15.75C7.5 14.6454 8.39543 13.75 9.5 13.75H20.25V10.805C20.2496 10.6615 20.2178 10.5187 20.1585 10.3911C20.1245 10.3287 20.0814 10.2709 20.0303 10.2197L19.8105 10H14.5C13.8096 10 13.25 9.44036 13.25 8.75V3.43945L13.0303 3.21972C12.9426 3.13201 12.8354 3.06824 12.7189 3.03267C12.6382 3.01116 12.5544 3 12.4695 3H5.66717Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.9875 16.7625C11.3395 16.7625 11.625 17.0479 11.625 17.4C11.625 17.7521 11.3395 18.0375 10.9875 18.0375H10.35V16.7625H10.9875ZM9.07495 16.125C9.07495 15.9617 9.13633 15.8128 9.23728 15.7C9.35401 15.5696 9.52365 15.4875 9.71245 15.4875H10.9875C11.4429 15.4875 11.8612 15.6467 12.1896 15.9125C12.6229 16.2631 12.9 16.7992 12.9 17.4C12.9 17.6235 12.8616 17.8381 12.7911 18.0375C12.5286 18.7803 11.8202 19.3125 10.9875 19.3125H10.35V20.375C10.35 20.7271 10.0645 21.0125 9.71245 21.0125C9.36037 21.0125 9.07495 20.7271 9.07495 20.375V16.125Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.3875 15.4875C14.0354 15.4875 13.75 15.7729 13.75 16.125V20.375C13.75 20.7271 14.0354 21.0125 14.3875 21.0125H15.4803C16.6201 21.0125 17.575 20.1096 17.575 18.9583V17.5417C17.575 16.3904 16.6201 15.4875 15.4803 15.4875H14.3875ZM16.2098 19.3125C16.0767 19.56 15.8075 19.7375 15.4803 19.7375H15.025V16.7625H15.4803C15.95 16.7625 16.3 17.1282 16.3 17.5417V18.9583C16.3 19.0837 16.2678 19.2047 16.2098 19.3125Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.0625 21.0125C19.137 21.0125 19.2085 20.9997 19.275 20.9762C19.5226 20.8887 19.7 20.6525 19.7 20.375V18.8875H21.1875C21.5395 18.8875 21.825 18.6021 21.825 18.25C21.825 17.8979 21.5395 17.6125 21.1875 17.6125H19.7V16.7625H21.6125C21.9645 16.7625 22.25 16.4771 22.25 16.125C22.25 15.7729 21.9645 15.4875 21.6125 15.4875H19.0625C18.7104 15.4875 18.425 15.7729 18.425 16.125V20.375C18.425 20.7271 18.7104 21.0125 19.0625 21.0125Z"
				fill="currentColor"
			/>
			<circle cx="18.75" cy="5" r="4" fill="#1E72BD" stroke="white" strokeWidth="2" />
		</svg>
	);
}

PdfNotificationFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PdfNotificationFilledIcon;
